import ScrollVelocity from "../../components/navbar/ScrollVelocity/ScrollVelocity";

export default function CallToAction() {
  return (
    <section
      className="relative py-40 bg-cover bg-center"
      style={{ backgroundImage: "url('/img/landing/cta.jpeg')" }}
    >
      {/* Overlay oscuro */}
      <div className="absolute inset-0 bg-black bg-opacity-60"></div>

      {/* Contenido */}
      <div className="relative">
        <ScrollVelocity
          texts={["Protección Integral para tu Hogar y Negocio"]}
          velocity={15}
          className="custom-scroll-text text-white"
        />
      </div>
    </section>
  );
}
